import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import DashboardLayout from "@/components/layout/DashboardLayout";

import LoginPage from "@/pages/LoginPage";
import { ForgotPasswordPage, ResetPasswordPage } from "@/pages/PasswordResetPages";
import { PrivacyPage, TermsPage } from "@/pages/LegalPages";
import OverviewPage from "@/pages/OverviewPage";
import ClientPortfolioPage from "@/pages/ClientPortfolioPage";
import CreditPipelinePage from "@/pages/CreditPipelinePage";
import { PersonalCapitalStrategyPage, BusinessCapitalStrategyPage } from "@/pages/CapitalStrategyPages";
import ProfilePositioningPage from "@/pages/TradelineTrackerPage";
import GrantTrackerPage from "@/pages/GrantTrackerPage";
import DocumentQueuePage from "@/pages/DocumentQueuePage";
import ReferralLeaderboardPage from "@/pages/ReferralLeaderboardPage";
import RevenuePage from "@/pages/RevenuePage";
import BusinessFoundationPage from "@/pages/BusinessFoundationPage";
import EventsPage from "@/pages/EventsPage";
import LeadsPage from "@/pages/LeadsPage";
import BillingPage from "@/pages/BillingPage";
import PaymentsPage from "@/pages/PaymentsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <DashboardLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<OverviewPage />} />
              <Route path="leads" element={<LeadsPage />} />
              <Route path="clients" element={<ClientPortfolioPage />} />

              {/* Canonical product routes */}
              <Route path="financial-profile-development" element={<CreditPipelinePage />} />
              <Route path="personal-capital-strategy" element={<PersonalCapitalStrategyPage />} />
              <Route path="business-capital-strategy" element={<BusinessCapitalStrategyPage />} />
              <Route path="profile-positioning-services" element={<ProfilePositioningPage />} />
              <Route path="grant-readiness-and-funding-research" element={<GrantTrackerPage />} />
              <Route path="business-foundation-and-entity-setup" element={<BusinessFoundationPage />} />

              {/* Legacy route aliases — keep working during transition */}
              <Route path="credit" element={<Navigate to="/financial-profile-development" replace />} />
              <Route path="funding" element={<Navigate to="/business-capital-strategy" replace />} />
              <Route path="tradelines" element={<Navigate to="/profile-positioning-services" replace />} />
              <Route path="grants" element={<Navigate to="/grant-readiness-and-funding-research" replace />} />
              <Route path="business-foundation" element={<Navigate to="/business-foundation-and-entity-setup" replace />} />

              {/* Operational tools */}
              <Route path="documents" element={<DocumentQueuePage />} />
              <Route path="referrals" element={<ReferralLeaderboardPage />} />
              <Route path="revenue" element={<RevenuePage />} />
              <Route path="billing" element={<BillingPage />} />
              <Route path="payments" element={<PaymentsPage />} />
              <Route path="events" element={<EventsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
